import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect, Switch } from 'react-router-dom'
import './common/css/reset.css'
import './common/css/bootstrap/bootstrap-grid.scss'
import './common/css/sos-icons.scss'
import './common/css/global.scss'
import './common/css/animate.css'
import { parseUrlQuery, hydrateSublinkFunctions } from 'utilities'
import { Content, SidebarNav, Footer } from 'components/Shell/Shell'
import Home from 'components/Home/Home'
import Search from 'components/Search/Search'
import PrintResults from 'components/PrintResults/PrintResults'
import Lists from 'components/Lists/Lists'
import { LobbyistList } from 'components/Lists/List'
import FormManager from 'components/FormManager/FormManager'
import Forms from 'components/Forms/Forms'
// import Designer2 from 'components/Designer2/Designer2'
import DeferredDesigner from 'components/Designer2/DeferredDesigner'
import {
	ConnectedWizard,
	DraftEditor,
	CorrectionEditor,
	ReadOnlyWizard,
	AmendmentEditor,
	SignaturesWizard
} from 'components/Wizard2/Wizard'
import MyRecords from 'components/MyRecords/MyRecords'
import MyWorkQueue from 'components/MyWorkQueue/MyWorkQueue'
import ReceiptPage from 'components/Checkout/ReceiptPage'
import PaymentError from 'components/Checkout/Error'
// import Dashboard from 'components/Dashboard/Dashboard'
import DeferredDashboard from 'components/Dashboard/DeferredDashboard'
import LoginRedirector from 'components/LoginRedirector/LoginRedirector'
import { AdminLoginPage } from 'components/Shell/Login/Login'
import ChangePassword from 'components/Shell/Login/ChangePassword'
import { getAuthState, registerAuthPoll, skipAuthCheck } from './Auth/AuthActions'
import { initializeApp } from './actions'
import Migrate from 'components/Migrate/Migrate'
import HomeIcon from '@tecuity/sos-icons/react/home'
import GaugeIcon from '@tecuity/sos-icons/react/gauge'
// import SearchDocsIcon from '@tecuity/sos-icons/react/search-docs'
// import RSSIcon from '@tecuity/sos-icons/react/rss'
import DatabaseIcon from '@tecuity/sos-icons/react/database'
import SearchIcon from '@tecuity/sos-icons/react/search-thin'
import DocumentCloneIcon from '@tecuity/sos-icons/react/document-clone'
import BulletListIcon from '@tecuity/sos-icons/react/bullet-list'
import FileBoxIcon from '@tecuity/sos-icons/react/file-box'
import FileBoxTimeIcon from '@tecuity/sos-icons/react/file-box-time'
import GearsIcon from '@tecuity/sos-icons/react/gears'
import HelpIcon from '@tecuity/sos-icons/react/question-mark'
import { Helmet } from "react-helmet";
import { LoginRedirectSwitch } from 'components/LoginRedirector/LoginRedirector'
import DeferredHealthCareDirective from 'components/HealthCareDirective/DeferredHealthCareDirective'
import NotFound from 'components/NotFound/NotFound'
import VerifyCertificate from 'components/Certificates/VerifyCertificate'
import Toast from 'components/Toast/Toast'
import PaymentCallback from 'components/Checkout/PaymentCallback'
import PinsPage from 'components/MyRecords/PinsPage'
import DataRequests from 'components/DataRequests/DataRequests'
import EpassCallback from 'components/Epass/EpassCallback'
import EpassRedirector from './components/Epass/EpassRedirector'
import EpassLogout from './components/Epass/EpassLogout'
import FarmBill from './components/FarmBill/FarmBill'
import SystemAdmin from './components/SystemAdmin/SystemAdmin'
import ApostilleVerification from './components/ApostilleVerification/ApostilleVerification'
import SignaturesManage from 'components/Signatures/ManageSignatures'
import VersionPage from 'components/Version/Version'
import UnsupportedBrowser from 'components/UnsupportedBrowser/UnsupportedBrowser'
import Announcer from 'components/Announcer/Announcer'


let OktaCallback, OktaRedirector;
/// #if useOkta === true
OktaCallback = require('./components/Okta/OktaCallback').default
OktaRedirector = require('./components/Okta/OktaRedirector').default
/// #endif

export const DISABLE_AUTH_CHECK = process.env.NODE_ENV == 'development' && false;

export const ADDITIONAL_ROUTES = process.env.ADDITIONAL_ROUTES || {};

export const SUBROUTES = Array.isArray(process.env.SUBROUTES) ? process.env.SUBROUTES : [];
const constructSubroutes = path => {
  return SUBROUTES.filter(route => {
    if(route.allowedRoutes){
      return route.allowedRoutes.includes(path)
    }
    return route.disabled !== true;
  }).map(route => hydrateSublinkFunctions({
    ...route,
    path: path + route.parameter
  }))
}

export const SUBROUTES_OBJ = SUBROUTES.reduce((obj, route) => ({...obj, [route.parameter]: route}), {})

export const routes = [
  {
    label: "Home",
    title: 'Online Business Services',
    includeInSidebar: true,
    icon: <HomeIcon/>,
    component: Home,
    exact: true,
    link: "/",
    path: "/",
    subLinks: [],
		linkAvailableOffline: true
  },
  ...(ADDITIONAL_ROUTES.dashboard ? [{
    label: "Dashboard",
    title: 'Dashboard',
    includeInSidebar: true,
    icon: <GaugeIcon/>,
    component: DeferredDashboard,
    exact: true,
		// collapseSidebar: true,
    link: "/dashboard",
    path: "/dashboard",
    subLinks: [],
    authOnly: true,
    allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
  }] : []),
  {
    label: "Search",
    title: 'Search',
    includeInSidebar: true,
    icon: <SearchIcon/>,
    component: Search,
    link: "/search",
    path: "/search/:subParam?",
    subLinks: constructSubroutes('/search/'),
		linkAvailableOffline: true
  },
  {
    label: "Print Results",
    title: 'Print Results',
    includeInSidebar: false,
    component: PrintResults,
    link: "/print-results",
    path: "/print-results",
		linkAvailableOffline: true,
		hideAppShell: true
  },
  {
    label: "Forms",
    title: 'Forms',
    includeInSidebar: true,
    icon: <DocumentCloneIcon/>,
    component: Forms,
    path: "/forms/:category?",
    link: "/forms",
    exact: true,
    linkExact: false,
    // isActive: (match, location) => location.pathname.includes('/forms'),
    subLinks: constructSubroutes('/forms/'),
		allowedUserGroups: ['ADMIN', 'ADMIN_WEB', 'WEB']
  },
  {
    label: "Wizard Filing",
    title: 'File',
    includeInSidebar: false,
    icon: <DocumentCloneIcon/>,
    component: ConnectedWizard,
    path: "/forms/new/:formDefinitionId",
    link: "/forms/0",
    subLinks: [],
    authOnly: false,
		allowedUserGroups: ['ADMIN_WEB', 'WEB']
  },
  {
    label: "Wizard Sign",
    title: 'Sign',
    includeInSidebar: false,
    icon: <DocumentCloneIcon/>,
    component: SignaturesWizard,
    path: "/forms/sign/:token",
    link: "/forms/0",
    subLinks: [],
    authOnly: false
  },
  ...(ADDITIONAL_ROUTES.lists !== false ? [{
    label: "Lists",
    title: 'Lists',
    includeInSidebar: true,
    component: Lists,
    icon: <BulletListIcon/>,
    path: "/lists",
    link: "/lists",
    exact: true,
    subLinks: [],
		linkAvailableOffline: true
  }] : []),
  {
    label: "Registered Lobbyists",
    title: 'Registered Lobbyists',
    includeInSidebar: false,
    component: LobbyistList,
    icon: <BulletListIcon/>,
    path: "/lists/lobbyist",
    link: "/lists/lobbyist?rangeid=1",
    subLinks: []
  },
  {
    label: "My Work Queue",
    title: 'My Work Queue',
    includeInSidebar: true,
    component: MyWorkQueue,
    icon: <FileBoxTimeIcon/>,
    link: '/queue',
    path: '/queue/:category?',
    subLinks: constructSubroutes('/queue/'),
    authOnly: true,
		allowedUserGroups: ['ADMIN_WEB', 'WEB']
  },
  {
    label: "My Records",
    title: 'My Records',
    includeInSidebar: true,
    icon: <FileBoxIcon/>,
    link: "/records",
    path: "/records/:subParam?",
    component: MyRecords,
    subLinks: constructSubroutes('/records/'),
		allowedUserGroups: ['ADMIN_WEB', 'WEB'],
    // numAlerts: 1,
    authOnly: true
  },
	...(ADDITIONAL_ROUTES.dataRequests ? [{
		label: process.env.DATA_REQUEST_SIDEBAR_LABEL || "Data Requests",
		title: process.env.DATA_REQUEST_SIDEBAR_LABEL || "Data Requests",
		includeInSidebar: true,
		icon: <DatabaseIcon />,
		component: DataRequests,
		path: '/data-requests',
		link: '/data-requests',
		authOnly: true,
		alwaysShowInSidebar: process.env.DATA_REQUEST_ALWAYS_SHOW_IN_SIDEBAR || false,
		allowedUserGroups: ['ADMIN_WEB', 'WEB'],
		// subLinks: constructSubroutes('/data-requests/')
	}] : []),
  {
    label: "Forms Manager",
    title: 'Forms Manager',
    includeInSidebar: true,
    icon: <DocumentCloneIcon/>,
    component: FormManager,
    exact: true,
    linkExact: false,
    path: "/forms-manager/:category?",
    link: "/forms-manager",
    subLinks: constructSubroutes('/forms-manager/'),
    authOnly: true,
    allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
  },
  {
    label: "Form Designer",
    title: 'Edit',
    includeInSidebar: false,
    icon: <DocumentCloneIcon/>,
    component: DeferredDesigner,
    path: "/forms-manager/edit/:formDefinitionId",
    link: "/forms-manager/edit/0",
    subLinks: [],
    collapseSidebar: true,
    authOnly: true,
		allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
  },
  ...(ADDITIONAL_ROUTES.systemAdministration !== undefined ? [{
    label: "System Administration",
    title: 'System Administration',
    includeInSidebar: true,
    icon: <GearsIcon/>,
    component: SystemAdmin,
    path: "/system-admin/:parameter?",
    link: "/system-admin",
    subLinks: [],
    authOnly: true,
		allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
  }] : []),
  {
    label: "Receipt",
    title: 'Payment Successful',
    includeInSidebar: false,
    iconClass: "",
    component: ReceiptPage,
    path: "/receipt",
    link: "/receipt",
    subLinks: [],
    // authOnly: true
  },
	{
		label: "Signatures Manager",
		title: "Signatures Manager",
		includeInSidebar: false,
		iconClass: "",
		component: SignaturesManage,
		path: "/signatures/:groupToken",
		link: "/signatures/:groupToken",
		subLinks: []
	},
  {
    label: "PaymentCallback",
    title: 'Processing Payment',
    includeInSidebar: false,
    iconClass: "",
    component: PaymentCallback,
    path: "/processpayment/:method",
    link: "/processpayment",
    subLinks: [],
    // authOnly: true
  },
  {
    label: 'Payment Error',
    title: 'Error Processing Payment',
    includeInSidebar: false,
    component: PaymentError,
    path: "/paymenterror/:method",
    link: '/paymenterror/:method',
    subLinks: [],
    authOnly: false
  },
  {
    label: "Draft",
    title: 'Draft',
    includeInSidebar: false,
    iconClass: "",
    component: DraftEditor,
    path: "/draft/:draftId",
    link: "/draft",
    subLinks: [],
    authOnly: true,
		allowedUserGroups: ['ADMIN_WEB', 'WEB']
  },
  {
    label: "Correction",
    title: 'Correction',
    includeInSidebar: false,
    iconClass: "",
    component: CorrectionEditor,
    path: "/correct/:formDefinitionId/:amendmentNum",
    link: "/correct",
    subLinks: [],
    authOnly: true,
		allowedUserGroups: ['ADMIN_WEB', 'WEB']
  },
  {
    label: "Amend",
    title: 'Amend',
    includeInSidebar: false,
    iconClass: "",
    component: AmendmentEditor,
    path: "/amend/:formDefinitionId/:amendmentNum",
    link: '/amend',
    subLinks: [],
    authOnly: process.env.AMEND_ROUTE_PUBLIC ? false : true,
		allowedUserGroups: ['ADMIN_WEB', 'WEB']
  },
  {
    label: "ChangePassword",
    includeInSidebar: false,
    iconClass: "",
    component: ChangePassword,
    path: '/passwordreset',
    link: '/passwordreset',
    subLinks: [],
    authOnly: false
  },
  {
    label: "LoginRedirector",
    title: "Login",
    includeInSidebar: false,
    iconClass: "",
    component: process.env.LOGIN_REDIRECTS_TO_EPASS
                ? EpassRedirector
                : (
                    process.env.HAS_OKTA_LOGIN
                      ? OktaRedirector
                      : LoginRedirector
                  ),
    path: '/auth/:returnPath?',
    link: '/auth',
    subLinks: [],
    authOnly: false
  },
  {
    label: "AdminLogin",
		title: "Admin Login",
    includeInSidebar: false,
    iconClass: "",
    component: AdminLoginPage,
    path: '/admin',
    link: '/admin',
    sublinks: [],
    authOnly: false
  },
  // {
  //   label: "Reset Password",
  //   title: "Reset Password",
  //   includeInSidebar: false,
  //   iconClass: "",
  //   component: ResetPassword,
  //   path: '/passwordreset',
  //   link: '/passwordreset',
  //   sublinks: [],
  //   authOnly: false
  // },
  {
    label: "ReadOnlyWizard",
    includeInSidebar: false,
    iconClass: "",
    component: ReadOnlyWizard,
    path: "/view/:formDefinitionId/:amendmentNum",
    link: '/view',
    subLinks: [],
    authOnly: true,
		allowedUserGroups: ['ADMIN_WEB', 'WEB']
  },
  {
    label: 'Wizard Migration Tool',
    title: 'Migrate',
    includeInSidebar: false,
    iconClass: "",
    component: Migrate,
    path: '/migrate',
    link: '/migrate',
    sublinks: [],
    authOnly: true,
		allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
  },
  {
    label: 'Verify Certificates',
    title: 'Verify Certificates',
    includeInSidebar: false,
    iconClass: "",
    component: VerifyCertificate,
    path: '/verifycertificate',
    link: '/verifycertificate',
    sublinks: [],
    authOnly: false,
  },
	{
		label: 'Epass Login',
		title: 'Epass Login',
		includeInSidebar: false,
		iconClass: "",
		component: EpassCallback,
		path: '/epass-callback',
		link: '/epass-callback',
		sublinks: [],
		authOnly: false
	},
	{
		label: 'Epass Logout',
		title: 'Epass Logout',
		includeInSidebar: false,
		iconClass: "",
		component: EpassLogout,
		path: '/epass-logout',
		link: '/epass-logout',
		sublinks: [],
		authOnly: false
  },
  ...(process.env.HAS_OKTA_LOGIN ? [{
    label: 'Okta Callback',
    title: 'Okta Callback',
    includeInSidebar: false,
    iconClass: '',
    component: OktaCallback,
    path: '/okta-callback',
    link: '/okta-callback',
    sublinks: [],
    authOnly: false
  }] : []),
  ...(ADDITIONAL_ROUTES.farmBill ? [{
		label: "Farm Bill",
		title: 'Farm Bill Search',
		path: '/lists/:subParam',
		link: '/lists/:subParam',
		component: FarmBill,
		subLinks: [process.env.FARM_BILL_SUBLINK],
		authOnly: true,
		allowedUserGroups: ['ADMIN', 'ADMIN_WEB', 'WEB']
	}] : []),
	...(ADDITIONAL_ROUTES.externalHelp !== undefined && ADDITIONAL_ROUTES.externalHelp !== false ? [{
	  label: "Help",
	  title: "Help",
	  path: ADDITIONAL_ROUTES.externalHelp,
	  link: ADDITIONAL_ROUTES.externalHelp,
	  authOnly: false,
	  includeInSidebar: true,
	  linkAvailableOffline: true,
	  external: true,
	  icon: <HelpIcon/>
	}] : []),
	...(ADDITIONAL_ROUTES.genericPins ? [{
		label: 'Enter PIN',
		title: 'Enter PIN',
		includeInSidebar: false,
		iconClass: '',
		component: PinsPage,
		path: '/pins',
		link: 'pins',
		sublinks: '',
		authOnly: false,
		codeSplit: true
	}] : []),
  ...(process.env.NODE_ENV === 'development' ? [{
    label: 'Sandbox',
    title: 'Sandbox',
    includeInSidebar: true,
    icon: <GearsIcon/>,
    component: Sandbox,
    path: '/sandbox',
    link: '/sandbox',
    codeSplit: true,
    collapseSidebar: true,
		linkAvailableOffline: true
  }] : []),
  ...(ADDITIONAL_ROUTES.healthCareDirective ? [{
    label: 'Health Care Directive',
    title: 'Health Care Directive',
    includeInSidebar: false,
    component: DeferredHealthCareDirective,
    path: '/hcdr',
    link: '/hcdr',
    codeSplit: true,
    collapseSidebar: false
  }] : []),
  ...(ADDITIONAL_ROUTES.apostille ? [{
    label: 'Apostille Verification',
    title: 'Apostille Verification',
    includeInSidebar: false,
    component: ApostilleVerification,
    path: '/apostille',
    link: '/apostille',
    codeSplit: true,
    collapseSidebar: false
  }] : []),
	{
	  label: "Version",
	  title: "Version",
	  includeInSidebar: false,
		path: '/version',
		link: '/version',
		authOnly: false,
	  component: VersionPage
	}
]

class App extends Component {
  componentDidMount = () => {
		const skipAuthCheck = (parseUrlQuery(this.props.location.search || '?') || {}).skipAuthCheck
    if(!skipAuthCheck){
			this.props.getAuthState()
		}else{
			this.props.skipAuthCheck()
		}
    // this.props.registerAuthPoll()
    this.props.initializeApp()
  }
  componentWillReceiveProps = nextProps => {
    const mobileLocationHasChanged = nextProps.isMobile && this.props.location.pathname !== nextProps.location.pathname;
    if(mobileLocationHasChanged){
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }
	componentDidCatch = err => {
    switch (err.name) {
      case 'AuthSdkError':
        this.setState({showBrowserUpgradeMessage: true})
        break;
      default:

    }
	}
  render() {
    const {location, loggedIn, userGroup, siteOffline, isUnsupportedBrowser} = this.props;

    return (
			<div className={`App ${isUnsupportedBrowser ? 'unsupported-browser' : ''}`}>
        <SidebarNav links={routes} location={location} />
        <Switch>
					{routes.map((route, i) => (
	            <Route path={route.path} exact={route.exact} render={props => {
	              let renderedComponent = (
	                <Content
									  currentPath={location.pathname}
									  links={routes}
										currentRoute={route}
									  subLinks={route.subLinks}
									  authOnly={route.authOnly}
									  sidebarCollapsed={route.collapseSidebar}
										hideAppShell={route.hideAppShell}
										hideSidebar={route.hideSidebar}
									>
									  <Helmet>
									    <title>{`${route.title || ""} | ${process.env.STATE_NAME} ${
									      process.env.STATE_ORG_TITLE
									    }`}</title>
									  </Helmet>
									  <route.component {...props} sublinks={route.subLinks} />
									</Content>
	              )
	              if(route.authOnly){
									if(siteOffline){
										return <Redirect to='/' />
									}
	                if(loggedIn){
	                  if(route.allowedUserGroups){
	                    if(route.allowedUserGroups.includes(userGroup)){
	                      return renderedComponent
	                    }else{
	                      return <Redirect to='/' />
	                    }
	                  }else{
	                    return renderedComponent
	                  }
	                }else{
	                  return <LoginRedirectSwitch location={location} />
	                }
	              }else{
	                return renderedComponent
	              }
	            }} key={i} />
	        ))}
					<Route render={props => (
						<Content
							currentPath={location.pathname}
							links={routes}
							currentRoute={{}}
							subLinks={[]}
							authOnly={false}
							sidebarCollapsed={false}
						>
							<Helmet>
								<title>{`404 Not Found | ${process.env.STATE_NAME} ${
									process.env.STATE_ORG_TITLE
								}`}</title>
							</Helmet>
							<NotFound />
						</Content>
					)} />
				</Switch>
        <Toast danger={!!this.props.toastError} success={!!this.props.toastSuccess} message={this.props.toastError || this.props.toastSuccess} />
				<Footer copyright={`${process.env.STATE_ABBR} Secretary of State`} />
				{
					isUnsupportedBrowser && <UnsupportedBrowser />
				}
				<Announcer />
      </div>
    )
  }
}

export default connect(
  (state)=>({
    loggedIn: state.auth.loggedIn,
    userGroup: state.auth.USER_GROUP,
    isMobile: state.app.isMobile,
    toastError: state.app.toastError,
    toastSuccess: state.app.toastSuccess,
		siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
		isUnsupportedBrowser: state.app.isUnsupportedBrowser
  }),
  {getAuthState, initializeApp, registerAuthPoll, skipAuthCheck}
)(App);



// WEBPACK FOOTER //
// ./src/App.js